import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const getStatusMessage = isAwayMode => {
  const common = {
    'data-test-id': 'agent-status-text',
    'data-test-isAvailable': !isAwayMode
  };
  return isAwayMode ? /*#__PURE__*/_jsx(FormattedMessage, Object.assign({}, common, {
    message: "routing-ui.agent-status.agentIsAway"
  })) : /*#__PURE__*/_jsx(FormattedMessage, Object.assign({}, common, {
    message: "routing-ui.agent-status.agentIsAvailable"
  }));
};